export class SummaryModel{

    private _firstName: string = ''
    private _lastName: string = ''
    private _role: Array<string> = []
    private _email: string = ''
    private _phone: string = ''
    private _address: string = ''
    private _linkedin: string = ''
    private _github: string = ''
    private _youtube: string = ''
    private _facebook: string = ''
    private _instagram: string = ''
    private _twitter: string = ''
    private _portFolio: string = ''
    private _profile: string = ''
    private _dateOfBirth:string = ''
    private _about:string = ''
    private _yearsOfExperience: number = 0
    private _highestGrade:string = ''


    get dateOfBirth(): string {
        return this._dateOfBirth;
    }

    set dateOfBirth(value: string) {
        this._dateOfBirth = value;
    }

    get about(): string {
        return this._about;
    }

    set about(value: string) {
        this._about = value;
    }

    get profile(): string {
        return this._profile;
    }

    set profile(value: string) {
        this._profile = value;
    }

    get firstName(): string {
        return this._firstName;
    }

    set firstName(value: string) {
        this._firstName = value;
    }

    get lastName(): string {
        return this._lastName;
    }

    set lastName(value: string) {
        this._lastName = value;
    }

    get role(): Array<string> {
        return this._role;
    }

    set role(value: Array<string>) {
        this._role = value;
    }

    get email(): string {
        return this._email;
    }

    set email(value: string) {
        this._email = value;
    }

    get phone(): string {
        return this._phone;
    }

    set phone(value: string) {
        this._phone = value;
    }

    get address(): string {
        return this._address;
    }

    set address(value: string) {
        this._address = value;
    }

    get linkedin(): string {
        return this._linkedin;
    }

    set linkedin(value: string) {
        this._linkedin = value;
    }

    get github(): string {
        return this._github;
    }

    set github(value: string) {
        this._github = value;
    }

    get youtube(): string {
        return this._youtube;
    }

    set youtube(value: string) {
        this._youtube = value;
    }

    get facebook(): string {
        return this._facebook;
    }

    set facebook(value: string) {
        this._facebook = value;
    }

    get instagram(): string {
        return this._instagram;
    }

    set instagram(value: string) {
        this._instagram = value;
    }

    get twitter(): string {
        return this._twitter;
    }

    set twitter(value: string) {
        this._twitter = value;
    }

    get portFolio(): string {
        return this._portFolio;
    }

    set portFolio(value: string) {
        this._portFolio = value;
    }


    get yearsOfExperience(): number {
        return this._yearsOfExperience;
    }

    set yearsOfExperience(value: number) {
        this._yearsOfExperience = value;
    }

    get highestGrade(): string {
        return this._highestGrade;
    }

    set highestGrade(value: string) {
        this._highestGrade = value;
    }
}